export default __webpack_public_path__ + "static/media/starstruckCover.3948f230.jpeg";